<template>
  <ActivityForm />
</template>
  
<script>
  import ActivityForm from '@/components/tournament-activity/ActivityForm.vue';
  export default {
    name: "ClassCreatePage",
    components: {
      ActivityForm,
    },
  };
</script>
  